export const defaultFontFamily = 'sans-serif';
